export const toUserId = (value) => {
    if (value == null || value === "") {
        return null;
    }

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
};

export const getAssignedDpoUser = (organizationFunction) => {
    const assignedUsers = organizationFunction?.assigned_users;

    if (!Array.isArray(assignedUsers) || !assignedUsers.length) {
        return null;
    }

    return assignedUsers[0] || null;
};

export const getDpoSyncAction = ({ currentAssignedUserId, pickerUserId } = {}) => {
    const currentId = toUserId(currentAssignedUserId);
    const pickerId = toUserId(pickerUserId);

    if (pickerId == null) {
        if (currentId != null) {
            return { type: "unassign", userId: currentId };
        }

        return { type: "skip" };
    }

    if (currentId == null) {
        return { type: "assign", userId: pickerId };
    }

    if (currentId === pickerId) {
        return { type: "skip" };
    }

    return { type: "replace", userId: pickerId };
};
